import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5be78512"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-field" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Varenavn", -1))
const _hoisted_3 = { class: "filter-field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Kategori", -1))
const _hoisted_5 = { class: "filter-field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Leverandør", -1))
const _hoisted_7 = { class: "filter-field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Produkttype", -1))
const _hoisted_9 = { class: "other-filters" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "other-filters__header" }, "Øvrige filtre", -1))
const _hoisted_11 = { class: "filter-field other-filters__select" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Merke", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "all" }, "Alle produkter", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "with-brand" }, "Produkter med merke", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "without-brand" }, "Produkter uten merke", -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "filter-checkbox" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Uten vekt", -1))
const _hoisted_19 = { class: "filter-checkbox" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Uten strekkode", -1))
const _hoisted_21 = { class: "filter-checkbox" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Uten bilde", -1))
const _hoisted_23 = { class: "filter-checkbox" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Uten beskrivelse", -1))
const _hoisted_25 = { class: "filter-checkbox" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Uten minimumsantall", -1))
const _hoisted_27 = { class: "filter-checkbox" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Fokusprodukt", -1))
const _hoisted_29 = { class: "filter-checkbox" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "På salg", -1))
const _hoisted_31 = { class: "filter-checkbox" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Inkluder utgåtte produkter", -1))
const _hoisted_33 = { class: "filter-checkbox" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Produkter med negativ lagerstatus", -1))
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "error" }
const _hoisted_37 = { class: "submit-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategorySelect = _resolveComponent("CategorySelect")!
  const _component_SupplierSelect = _resolveComponent("SupplierSelect")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
    class: "filter"
  }, [
    _createElementVNode("label", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        type: "search",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event))
      }, null, 512), [
        [_vModelText, _ctx.form.name]
      ])
    ]),
    _createElementVNode("label", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_CategorySelect, {
        modelValue: _ctx.form.categories,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.categories) = $event)),
        categories: _ctx.categories,
        "add-main-categories": true
      }, null, 8, ["modelValue", "categories"])
    ]),
    _createElementVNode("label", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_SupplierSelect, {
        suppliers: _ctx.suppliers,
        modelValue: _ctx.form.suppliers,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.suppliers) = $event))
      }, null, 8, ["suppliers", "modelValue"])
    ]),
    _createElementVNode("label", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_Multiselect, {
        options: _ctx.options,
        "value-prop": "id",
        mode: "tags",
        modelValue: _ctx.form.type,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.type) = $event))
      }, null, 8, ["options", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("label", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.brandFilter) = $event))
        }, _hoisted_16, 512), [
          [_vModelSelect, _ctx.form.brandFilter]
        ])
      ]),
      _createElementVNode("label", _hoisted_17, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.noWeight) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.form.noWeight]
        ]),
        _hoisted_18
      ]),
      _createElementVNode("label", _hoisted_19, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.noBarcode) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.form.noBarcode]
        ]),
        _hoisted_20
      ]),
      _createElementVNode("label", _hoisted_21, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.noImage) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.form.noImage]
        ]),
        _hoisted_22
      ]),
      _createElementVNode("label", _hoisted_23, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.noDescription) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.form.noDescription]
        ]),
        _hoisted_24
      ]),
      _createElementVNode("label", _hoisted_25, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.noMinimumStock) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.form.noMinimumStock]
        ]),
        _hoisted_26
      ]),
      _createElementVNode("label", _hoisted_27, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.featuredProduct) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.form.featuredProduct]
        ]),
        _hoisted_28
      ]),
      _createElementVNode("label", _hoisted_29, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.onSale) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.form.onSale]
        ]),
        _hoisted_30
      ]),
      _createElementVNode("label", _hoisted_31, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.outOfProduction) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.form.outOfProduction]
        ]),
        _hoisted_32
      ]),
      _createElementVNode("label", _hoisted_33, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.negativeStock) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.form.negativeStock]
        ]),
        _hoisted_34
      ])
    ]),
    (_ctx.form.hasErrors)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.errors, (error) => {
            return (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(error), 1))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_37, [
      _createVNode(_component_Button, {
        type: "submit",
        color: "primary",
        disabled: _ctx.form.processing
      }, {
        default: _withCtx(() => [
          (_ctx.form.processing)
            ? (_openBlock(), _createBlock(_component_SvgIcon, {
                key: 0,
                class: "animate-spin",
                type: "mdi",
                path: _ctx.loadingIcon
              }, null, 8, ["path"]))
            : _createCommentVNode("", true),
          _createTextVNode(" Søk ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 32))
}